import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';
import { getUCTDate } from '../../helper/dateTimeHelper';
import { MyReqSearchBoxType } from '../../pages/procedure/info-technology-process/epr-process/list-process-epr';
import { ITableParams } from '../../modules/table';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPListId = getEnv('REACT_APP_EPR_CODE_REQUEST_SP_LIST_ID');

const expand = 'expand=fields(select=Title, eDescription, eContent, eFileContent, eDeptHeadComment, eITLeadComment, eITHeadComment, eAssigneeComment, eApprovedBy, eApprovedDate,eApprovedStatus, eApprovedByITLead,eApprovedByITLeadStatus, eApprovedByITLeadDate,eApprovedByITHead ,eApprovedByITHeadStatus, eApprovedByITHeadDate, eAssignee,eAssigneeStatus,eAssigneeStatusDate, eRequestStatus, eRequestType, eSoftwareId, eDepartment, eUnit, eUnion, ePhoneNumber, eComments, ePins)';
export class EprCodeProcessService {

  static async getEPRCodeRequests(email: string, params?: ITableParams) {
    if (email.toLowerCase() === 'thiennv@viags.vn' || email.toLowerCase() === 'namdh@viags.vn' || email.toLowerCase() === 'trungdt@viags.vn' || email.toLowerCase() === 'hieppt@viags.vn' || email.toLowerCase() === 'botit@viags.vn'
    || email.toLowerCase() === 'tienhc@viags.vn' || email.toLowerCase() === 'huyth@viags.vn' || email.toLowerCase() === 'datnt@viags.vn' || email.toLowerCase() === 'sonnhong@viags.vn' || email.toLowerCase() === 'taidv@viags.vn' || email.toLowerCase() === 'thuonghh@viags.vn'
    || email.toLowerCase() === 'luubd@viags.vn' || email.toLowerCase() === 'nghitc@viags.vn' || email.toLowerCase() === 'phuocvd@viags.vn' || email.toLowerCase() === 'phuocnh@viags.vn' || email.toLowerCase() === 'duydd@viags.vn'){
      return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
        .then(res => res.data.value)
        .catch(err => { throw new RequestError(err) });
    }
    else{
      let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
      return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`))
        .then(res => res.data.value)
        .catch(err => { throw new RequestError(err) });
    }
  }

  static async getEPRCodeRequestsApprovalHistory(email: string) {
    let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getMyEPRCodeRequests(email: string, params: ITableParams) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
      .then((res) =>
        res.data.value.filter(
          (o: any) =>
            o.createdBy.user.email.toLowerCase() === email.toLowerCase()
        )
      )
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async filterMyEPRCodeRequests(params: MyReqSearchBoxType & { email: string }) {
    const { email, createdDateTime, displayName } = params

    const filter = `
      filter=
        fields/eApprovedBy eq '${email.toLowerCase()}'
        and (
          createdDateTime eq '${getUCTDate(createdDateTime)}' 
          or 
          createdBy/user/displayName eq '${displayName}'
          or
          createdBy/user/displayName eq '${displayName}'
        )
    `
    
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getEPRCodeRequest(id: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }
  static async getCodeVms(id: any) {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }
  static async addEPRCodeRequest(leaveRequest: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), leaveRequest)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateEPRCodeRequest(id: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async deleteEPRCodeRequest(id: any) {
    return api.delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async getHistory(id: any){
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/versions`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }
}